module.exports = __webpack_public_path__ + "img/rose-4.c4db1171.png";